import React from 'react'
import { WtaiUploadWidgetProps, UploadWidget } from '@chegg/paper-upload-widget'
import { Config } from '@chegg-wt/core/config'
import useUploadWidgetDemoPage from '@chegg-wt/core/hooks/useUploadWidgetDemoPage'
import { UploadWidgetContainer } from './styled'

const defaultProps = {
  site: Config.tokenSiteCode,
  authApiUrl: Config.authUrl,
  editorBaseUrl: Config.enableRedirectionToCWC
    ? `${Config.cheggEnvUrl}/tools/writing-center`
    : Config.writingUrl,
  initRSW: false,
  initFreshToken: false,
  headingText: '',
  subheadingText: '',
  pasteOnly: true,
}

/**
 * Evaluates a complex type one level deep for intellisense readability purposes
 *
 * Copied from https://stackoverflow.com/a/57683652
 */
type Expand<T> = T extends infer O ? { [K in keyof O]: O[K] } : never

/**
 * Any property in D will be made optional in T
 * Any property that was required in T but was not present
 *      in D will still be required in the new type
 */
type WithDefaults<T, D> = Expand<Omit<T, keyof D> & Partial<D>>

export type UCFUploadWidgetProps = WithDefaults<
  WtaiUploadWidgetProps,
  typeof defaultProps
>

type OverrideProps = Pick<UCFUploadWidgetProps, 'onUploadSuccess' | 'demoTextEnabled'>

export const CHECK_CATEGORIES = {
  GRAMMAR: 'grammar',
  PLAGIARISM: 'plagiarism',
  EXPERT_CHECK: 'expert-check',
} as const

export const UCFUploadWidget: React.FC<UCFUploadWidgetProps> = (props) => {
  const { demoTextEnabled, uploadPaper } = useUploadWidgetDemoPage()

  const { onUploadSuccess: origOnUploadSuccess } = props
  const overrideProps: OverrideProps = {
    demoTextEnabled,
    onUploadSuccess: (document: any): void => {
      uploadPaper()
      if (Config.enableRedirectionToCWC) {
        const { id, filename } = document

        const path = '/draft'

        const queryParams = {
          ...{ uploadId: id },
          filename,
          ...{ checkCategory: CHECK_CATEGORIES.GRAMMAR },
        }

        const redirectUrl = `${defaultProps.editorBaseUrl}${path}?${new URLSearchParams(
          queryParams
        )}`
        window.location.assign(redirectUrl)
        return
      }
      if (origOnUploadSuccess) {
        return origOnUploadSuccess(document)
      }
      const { redirect } = document
      return redirect()
    },
  }

  const finalProps: WtaiUploadWidgetProps = {
    ...defaultProps,
    ...props,
    ...overrideProps,
  }
  return (
    <UploadWidgetContainer pasteOnly={finalProps.pasteOnly}>
      <UploadWidget {...finalProps} />
    </UploadWidgetContainer>
  )
}
